<script setup>
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Navigation from "../Header/Navigation";
import FlashNotifications from "../Notifications/FlashNotifications";
const themeColor = computed(() => usePage().props.value.theme_color);

</script>

<template>
    <div class="min-h-full">
        <navigation />
        <main>
            <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <slot />
            </div>
        </main>
      <FlashNotifications />
    </div>
</template>

<style>
/** These styles override the primary color and it's pseudo elements **/
.bg-primary {
  background-color: v-bind('themeColor') !important;
}

.text-primary {
  color: v-bind('themeColor') !important;
}

.text-primary:hover {
  color: v-bind('themeColor') !important;
}

.hover\:text-primary:hover {
  color: v-bind('themeColor') !important;
}

.focus\:ring-primary:focus {
  --tw-ring-color: v-bind('themeColor') !important;
}

.border-primary {
  border-color: v-bind('themeColor') !important;
}

.focus\:border-primary:focus {
  border-color: v-bind('themeColor') !important;
}
</style>
